<template>
  <b-modal
    id="contact-tag-delete-modal"
    ref="addNumberModal"
    modal-class="settings-modal"
    size="sm"
    hide-header-close
    hide-footer >
    <template #modal-header>
      <h5>Add a phone number</h5>
    </template>
    <div class="text-center">
      Airtable or our form to create new number
    </div>
    <!-- <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template> -->
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AddNumberModal',
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  methods: {
    ...mapActions({
      
    }),
    show() {
      this.$refs.addNumberModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.addNumberModal.hide();
    },
  },
};
</script>
